import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { InvoicePartner } from '../../../../../_shared/model';
import { InvoiceRecipient } from '../../../../../_shared/model/accounting/invoiceRecipient.model';
import { BaseState } from '../../../../../_shared/state/base/base.state';
import { AccountingService, CommonService } from '../../../../pages/home/_services';

@Component({
    selector: 'app-acc-wid-cmn-payer-new-popup',
    templateUrl: './acc-wid-cmn-payer-new-popup.component.html',
    styles: [],
})
export class AccWidCmnPayerNewPopupComponent implements OnInit {
    @Input()
    public enableModalActions = true;

    @Input()
    public isEdit = false;

    @Input()
    public invoicePartner: InvoicePartner;

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onCancel = new EventEmitter<void>();
    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onSave = new EventEmitter<InvoicePartner>();

    public inputForm: FormGroup;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public zipCodes: any = [];
    public formSubmitted = false;
    public recipientForm: FormGroup;
    private isDisableForm = false;
    private contractorId: number = this.store.selectSnapshot(BaseState.activeContractorId);

    constructor(
        private fb: FormBuilder,
        private commonRest: CommonService,
        public activeModal: NgbActiveModal,
        private accrest: AccountingService,
        private store: Store,
    ) {}

    ngOnInit() {
        this.initZipCodes();
        this.createForm();
    }

    private initZipCodes(): void {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.commonRest.getZipCodes().subscribe((res: any[]) => {
            this.zipCodes = res;
        });
    }
    public createForm(): void {
        this.inputForm = this.fb.group(
            {
                name: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.required),
                addressName: new FormControl({
                    value: '',
                    disabled: this.isDisableForm,
                }),
                addressNumber: new FormControl({
                    value: '',
                    disabled: this.isDisableForm,
                }),
                postName: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.required),
                postNumber: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.required),
                taxId: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.minLength(8)),
                phone: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.minLength(9)),
                email: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.email),
                paymentDeadlineDays: new FormControl(
                    { value: this.invoicePartner?.paymentDeadlineDays || '', disabled: this.isDisableForm },
                    Validators.min(0),
                ),
                postBox: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.pattern('^[0-9]*$')),
                contractorId: this.contractorId,
                id: undefined,
                isDifferentRecipient: new FormControl({
                    value: this.invoicePartner?.recipients,
                    disabled: this.isDisableForm,
                }),
            },

            // {
            //     validators: [MfPayerValidators.atLeastOne(Validators.required, ['addressName', 'postBox'])],
            // },
        );
        if (!_.isNil(this.invoicePartner)) {
            this.inputForm.patchValue(this.invoicePartner);
        }
    }

    public fillCity(e: { zipCode: string; city: string }) {
        if (e.city) {
            this.inputForm.controls.postName.setValue(e.city);
        }
    }
    public fillPost(e: { zipCode: string; city: string }) {
        if (e.zipCode) {
            this.inputForm.controls.postNumber.setValue(e.zipCode);
        }
    }
    public saveCustomerPayer(): void {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const inputFormValue: any = this.inputForm.value;
        const isDifferentRec: boolean = inputFormValue.isDifferentRecipient;

        this.formSubmitted = true;

        if (!this.inputForm.valid) {
            return;
        }
        if (isDifferentRec && !this.recipientForm?.valid) {
            return;
        }
        const invoicePartner = new InvoicePartner().deserialize(this.inputForm.value);

        if (isDifferentRec) {
            const invoiceRecipient = new InvoiceRecipient().deserialize(this.recipientForm.value);
            //dodamo naslov in parternja, nato povežemo
            this.accrest
                .createUpdateInvoicePartner(this.contractorId, invoicePartner)
                .pipe(
                    mergeMap((invoicePartnerId: number) =>
                        this.accrest.createUpdateInvoiceRecipient(this.contractorId, invoiceRecipient).pipe(
                            mergeMap((invoiceRecipientId: number) => {
                                if (this.isEdit) {
                                    return of({});
                                }
                                return this.accrest.connectPartnerAndRecipient(this.contractorId, invoicePartnerId, invoiceRecipientId);
                            }),
                        ),
                    ),
                )
                .subscribe(() => {
                    if (this.enableModalActions) {
                        this.activeModal.close({ invoicePartner: invoicePartner, invoiceRecipient: invoiceRecipient });
                    } else {
                        this.onSave.emit(invoicePartner);
                    }
                });
        } else {
            this.accrest.createUpdateInvoicePartner(this.contractorId, invoicePartner).subscribe(partnerId => {
                if (_.isNil(invoicePartner.id)) invoicePartner.id = partnerId;

                if (this.enableModalActions) {
                    this.activeModal.close({ invoicePartner: invoicePartner });
                } else {
                    this.onSave.emit(invoicePartner);
                }
            });
        }
    }

    public onRecipientData(data: FormGroup): void {
        this.recipientForm = data;
    }

    public onCloseClick(): void {
        if (this.enableModalActions) {
            this.activeModal.dismiss();
        } else {
            this.onCancel.emit();
        }
    }
}
